<template>
  <div class="audience-size">
    <template v-if="displaySize || displaySize === 0">
      <svg-icon :icon="audience" :width="56" :height="33"></svg-icon>
      <h2>{{ displaySize | truncateAmount }}</h2>
      <p>Target Audience</p>
       <viewership-time-frame />
    </template>
  </div>
</template>

<script>
  import SvgIcon from '@/components/common/svgIcon/index'
  import audience from '@/assets/svg/audience.svg'
  import truncateAmount from '@/filters/truncateAmount'
  import ViewershipTimeFrame from './ViewershipTimeFrame'

  export default {
    components: {
      SvgIcon,
      ViewershipTimeFrame
    },
    filters: {
      truncateAmount
    },
    props: {
      size: Number
    },
    data () {
      return {
        audience
      }
    },
    computed: {
      displaySize () {
        return this.size || this.size === 0 ? this.size : null
      }
    }
  }
</script>

<style lang="scss">
  .audience-size {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;

    h2 {
      margin: 20px 0 0 0;
    }

    svg {
      fill: color(blues, normal)
    }

    p {
      margin-top: 10px;
      font-size: rem(17);
      line-height: rem(20);
    }
  }
</style>



// WEBPACK FOOTER //
// AudienceSize.vue?2ebdab6c